import PropTypes from "prop-types";
import { useHref, useNavigate, useSearchParams  } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
// material
import { styled } from "@material-ui/core/styles";
import {
  Divider,
  Box,
  PaginationItem,
  TablePagination,
  Table,
  TableContainer,
  TableCell,
  TableRow,
  Stack,
  TableBody,
  Typography,
  Avatar,
  ListItemIcon,
  Checkbox,
  Card,
  Button,
  FormControlLabel,
  Chip,
  DialogTitle,
  TextField,
  MenuItem,
  Tooltip,
} from "@material-ui/core";
// redux
import { useDispatch, useSelector } from "../../../redux/store";
//
import ContactToolbar from "./ContactToolbar";
import apiContact from "../../../api/contact";
import apiField from "../../../api/field";
import { objectID } from "../../../utils/objectID";
import ContactListHead from "./list/ContactListHead";
import Label from "../../Label";
import { useTheme } from "@material-ui/core/styles";
import AddIcon from "@mui/icons-material/Add";
import { sentenceCase } from "change-case";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import MenuPopover from "../../MenuPopover";
import { useTranslation } from "react-i18next";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import {
  newMessageFacebook,
  newMessageFacebookBySelectedContact,
  newMessageZalo,
  newMessageZaloBySelectedContact,
} from "../../../redux/slices/chat";
import { useSnackbar } from "notistack5";
import ContactItemAction from "./ContactItemAction";
import { DialogAnimate } from "../../animate";
import DialogSendMessage from "./DialogSendMessage";
import AlertFormListChat from "./alert/AlertFormListChat";
import { setContactSelected } from "../../../redux/slices/selected";
import FormActionTicket from "../../../pages/ticket/modal/formActionTicket";
import AlertFormTag from "./alert/AlertFormTag";
import DialogTransferContact from "./DialogTransferContact";
import DialogChangeAssigner from "./DialogChangeAssigner";
import Swal from "sweetalert2";
import RenderTagsCell from "./renderTagsCell";
import moment from "moment";
// ----------------------------------------------------------------------

const RootStyle = styled(Card)({
  flexGrow: 1,
  display: "flex",
  overflow: "hidden",
  flexDirection: "column",
});

// ----------------------------------------------------------------------selectedContact

ListContact.propTypes = {
  onOpenSidebar: PropTypes.func,
};

export default function ListContact({
  handleParamAssigner,
  isRefreshContact,
  setIsRefreshContact,
  onOpenSidebar,
  paramSearch,
  setRecords,
  handleParamSearch,
  numSelected,
  resetAllSearch,
  setParamSearch,
  loadingFieldContact,
}) {
  const anchorRef = useRef(null);
  const anchorOptionContactRef = useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { doCall } = useSelector((state) => state.janus);
  const theme = useTheme();
  const [selectedContact, setSelectedContact] = useState([]);
  const [dense, setDense] = useState(false);
  const [contactList, setContactList] = useState([]);
  const [searchParams] = useSearchParams();
  const pageParam = searchParams.get("page"); // lấy giá trị từ ?page=
  const initialPage = pageParam && !isNaN(Number(pageParam)) ? Number(pageParam) : 0;
  const rowsPerPageParam = searchParams.get("rows"); // lấy giá trị từ ?page=
  const initialrowsPerPage = rowsPerPageParam && !isNaN(Number(rowsPerPageParam)) ? Number(rowsPerPageParam) : 10;
  const [page, setPage] = useState(initialPage);
  const [order, setOrder] = useState("asc");
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState("name");
  const [isOpenConfiguration, setIsOpenConfiguration] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(initialrowsPerPage);
  const [totalContact, setTotalContact] = useState(0);
  const [exportContact, setExportContact] = useState(0);
  const [tableHeadContact, setTableHeadContact] = useState([]);
  const { t } = useTranslation();

  const [optionList, setOptionList] = useState({});
  const { enqueueSnackbar } = useSnackbar();
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogTag, setOpenDialogTag] = useState(false);
  const [isOpenModalSend, setIsOpenModalSend] = useState(false);
  const [listChatContact, setListChatContact] = useState([]);
  //ticket
  const [refreshTicket, setRefreshTicket] = useState(true);
  const [isReadOnly, setIsReadOnly] = useState(false);
  const handleCloseActionTicket = () => {
    setIsShowActionTicket(false);
    setSelectedTicket(null);
    setIsReadOnly(false);
    setTaskCompleted(false);
  };
  const [isShowActionTiket, setIsShowActionTicket] = useState(false);
  const [taskCompleted, setTaskCompleted] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [infoAddTicket, setInfoAddTicket] = useState(null);
  const [infoTagSelected, setInfoTagSelected] = useState(null);
  const [selectContact, setSelectContact] = useState([]);
  const [isOpenDialogTransferContact, setIsOpenDialogTransferContact] =
    useState(false);
  const [optionContact, setOptionContact] = useState("choose_option_contact");
  const [isOpenDialogChangeAssigner, setIsOpenDialogChangeAssigner] =
    useState(false);
  const [isOpenOptionContact, setIsOpenOptionContact] = useState(false);

  const handleCloseModalSend = () => {
    setIsOpenModalSend(false);
  };

  const handleOpenModalSend = (contact) => {
    setSelectContact(contact);
    setIsOpenModalSend(true);
  };

  const handleCall = (phoneNumber, infoContact) => {
    if (doCall) {
      doCall(phoneNumber, infoContact);
    } else {
      enqueueSnackbar("Bạn chưa kết nối với tổng đài", { variant: "error" });
    }
    //
  };
  const handleDelete = async (contactId) => {
    try {
      await apiContact.delete_force({
        contactId: contactId,
      });
      enqueueSnackbar("Xóa thành công", { variant: "success" });
      loadListContact();
    } catch (error) {
      enqueueSnackbar(error.response.data.message[0], { variant: "error" });
    }
  };
  const handleChat = async (contact) => {
    try {
      const res_add_support_dept = await apiContact.find_list_chat({
        contactId: contact?._id ? objectID(contact._id) : null,
        uid_zl: contact?.uid_zl,
        uid_fb: contact?.uid_fb,
      });
      if (res_add_support_dept.data.data.length > 1) {
        setOpenDialog(true);
        setListChatContact(res_add_support_dept.data.data);
      } else if (res_add_support_dept.data.data.length === 1) {
        const contact = res_add_support_dept.data.data[0];
        if (contact.channel === "facebook") {
          dispatch(newMessageFacebookBySelectedContact(contact));
        }
        if (contact.channel === "zalo") {
          dispatch(newMessageZaloBySelectedContact(contact));
        }
        setListChatContact(res_add_support_dept.data.data);
      } else {
        enqueueSnackbar("Không có cuộc trò chuyện", { variant: "warning" });
      }
      // enqueueSnackbar("Xóa thành công", { variant: 'success' });
    } catch (error) {
      enqueueSnackbar(error.response.data.message[0], { variant: "error" });
    }
  };
  const onCloseDialog = () => {
    setOpenDialog(false);
  };
  const onCloseDialogTag = () => {
    setOpenDialogTag(false);
  };
  const handleOpen = () => {
    setIsOpenConfiguration(true);
  };
  const handleClose = () => {
    setIsOpenConfiguration(false);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Nếu bạn muốn đồng bộ lại khi URL thay đổi:
  useEffect(() => {
    const newPage = searchParams.get("page");
    if (newPage && !isNaN(Number(newPage))) {
      setPage(Number(newPage));
    }
    const newRowsPerPage = searchParams.get("rows");
    if (newRowsPerPage && !isNaN(Number(newRowsPerPage))) {
      setRowsPerPage(Number(newRowsPerPage));
    }
  }, [searchParams]);
  const loadListContact = async () => {
    try {
      const res = await apiContact.view3({
        start: page,
        length: rowsPerPage,
        paramSearch,
      });
      setRecords(res.data.report_contact);
      setTotalContact(res.data.total);
      setContactList(res.data.data);
    } catch (error) {}
  };
  useEffect(() => {
    if (isRefreshContact) {
      loadListContact();
      setIsRefreshContact(false);
      setSelected([]);
    }
  }, [isRefreshContact]);
  const loadDataFieldStaff = async (param, type) => {
    try {
      const res_load_data_field_staff = await apiField.viewByField(param);
      const data = res_load_data_field_staff.data.data;
      if (Object.keys(optionList).length > 0 && type != "reset") {
        const optionListClone = { ...optionList };
        Object.keys(data).map((item) => {
          optionListClone[item] = data[item];
        });
        setOptionList(optionListClone);
      } else {
        setOptionList(res_load_data_field_staff.data.data);
      }
    } catch (error) {}
  };
  useEffect(() => {
    if (paramSearch) {
      const timeoutId = setTimeout(() => {
        // setPage(0);
        // setRowsPerPage(10);
        loadListContact();
      }, 300);
      return () => clearTimeout(timeoutId);
    }
  }, [paramSearch]);
  useEffect(() => {
    // dispatch(getUserList());
    loadListContact();
  }, [page, rowsPerPage]);
  const handleAttributeContact = async (e) => {
    const attributeContactConfigurationClone = [...tableHeadContact];
    await apiField.updateFieldContact({
      field: e.target.name,
      is_show_table: e.target.checked,
    });
    attributeContactConfigurationClone.map((attr) => {
      if (attr.field_variable === e.target.name) {
        attr.is_show_table = e.target.checked;
      }
    });
    setTableHeadContact(attributeContactConfigurationClone);
  };
  const handleAttributeContactSearch = async (e) => {
    const attributeContactClone = [...tableHeadContact];
    try {
      await apiField.updateFieldContact({
        field: e.target.name,
        is_show_search: e.target.checked,
      });
      attributeContactClone.map((attr) => {
        if (attr.field_variable === e.target.name) {
          attr.is_show_search = e.target.checked;
        }
      });
    } catch (error) {}
    //loadDataFieldContact({ fields_name: [e.target.name], type: "custom" }, "field");
    if (!e.target.checked) {
      setParamSearch({ ...paramSearch, [e.target.name]: "" });
    }
    setTableHeadContact(attributeContactClone);
  };
  useEffect(() => {
    const export_contact = async () => {
      const res_report_contact = await apiContact.view3({
        paramSearch: paramSearch,
        exportContact: 1,
      });

      const url = window.URL.createObjectURL(
        new Blob([res_report_contact.data])
      );
      // tạo một thẻ a ẩn và kích hoạt sự kiện click để tải xuống tệp tin
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "export_contact.xlsx");
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      setExportContact(0);
    };
    if (exportContact) {
      export_contact();
    }
  }, [exportContact]);
  const handleSelectAllContact = () => {
    setSelectedContact(contactList.map((contact) => contact));
  };

  const handleToggleDense = () => {
    setDense((prev) => !prev);
  };

  const handleDeselectAllContact = () => {
    setSelectedContact([]);
  };

  const handleSelectOneMail = (mailId) => {
    setSelectedContact((prevSelectedContact) => {
      if (!prevSelectedContact.includes(mailId)) {
        return [...prevSelectedContact, mailId];
      }
      return prevSelectedContact;
    });
  };
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const contactListIds = contactList.map((n) => objectID(n._id));
      const newSelecteds = contactListIds.filter((q) => !selected.includes(q));
      setSelected(selected.concat(newSelecteds));
      return;
    } else {
      const remove_ids = contactList.map((n) => objectID(n._id));
      const newSelecteds = selected.filter((n) => !remove_ids.includes(n));
      setSelected(newSelecteds);
      return;
    }
    //setSelected([]);
  };

  const handleClick = (event, idContact) => {
    const selectedIndex = selected.indexOf(idContact);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, idContact);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };
  const handleDeselectOneMail = (mailId) => {
    setSelectedContact((prevSelectedContact) =>
      prevSelectedContact.filter((id) => id !== mailId)
    );
  };
  // const loadFieldContact = async () => {
  //   try {
  //     const resFieldStaff = await apiField.viewFieldContact();
  //     setTableHeadContact(resFieldStaff.data?.data);
  //   } catch (error) {}
  // };

  const loadFieldContact = async () => {
    try {
      const resFieldStaff = await apiField.viewFieldContact();

      const cleanedFieldData = resFieldStaff?.data?.data?.map((field) => ({
        ...field,
        value: field?.value ?? "", // Replace null/undefined with an empty string
      }));

      setTableHeadContact(cleanedFieldData || []);
    } catch (error) {
      console.error("Error loading field contact:", error);
      setTableHeadContact([]); // Fallback to empty array
    }
  };

  useEffect(() => {
    loadFieldContact();
    //loadDataFieldStaff({ fields_name: [], type: "all" }, "reset")
  }, [loadingFieldContact]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleSelectedContact = (infoContact, page) => {
    dispatch(setContactSelected(infoContact));
    navigate(`/contact/edit?page=${page}&rows=${rowsPerPage}`);
  };
  const handleOpenModalTicket = (infoContactTicket) => {
    setIsShowActionTicket(true);
    setInfoAddTicket(infoContactTicket);
  };
  const handleOpenDialogTag = (infoContact) => {
    setInfoTagSelected(infoContact);
    setOpenDialogTag(true);
  };
  const handleDeleteTag = async (param, tag) => {
    try {
      await apiContact.delete_tag({
        id: objectID(param._id),
        tag,
      });
      enqueueSnackbar("Xóa thành công", { variant: "success" });
      loadListContact();
      loadFieldContact();
    } catch (error) {
      enqueueSnackbar("Vui lòng kiểm tra lại nhãn", { variant: "error" });
    }
  };
  const onChangeOptionContact = (e) => {
    setOptionContact(e.target.value);
    if (e.target.value !== "choose_option_contact") {
      setIsOpenDialogChangeAssigner(true);
    } else {
      setIsOpenDialogChangeAssigner(false);
    }
  };
  const handleOpenOptionContact = () => {
    setIsOpenOptionContact(true);
  };
  const handleCloseAssigner = () => {
    setIsOpenDialogChangeAssigner(false);
    setIsOpenOptionContact(false);
  };
  const onHandleDeleteChecked = async () => {
    Swal.fire({
      title: "Bạn có muốn xóa danh bạ đang chọn không?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ffc107",
      confirmButtonText: "Xác nhận",
      cancelButtonText: "Hủy bỏ",
      showLoaderOnConfirm: true,
    }).then(async function (result) {
      if (result.isConfirmed) {
        try {
          await apiContact.deleteContactByIds({
            ids: selected,
          });
          enqueueSnackbar("Xóa thành công", { variant: "success" });
          setIsRefreshContact(true);
        } catch (error) {
          enqueueSnackbar(error.response.data.message[0], { variant: "error" });
        }
      }
    });
  };

  const renderAssignBy = (assigned_by_name) => {
    return assigned_by_name
      ? assigned_by_name?.length <= 30
        ? assigned_by_name
        : assigned_by_name.substr(0, 30) + "..."
      : "Chưa ai phụ trách";
  };

  return (
    <RootStyle>
      <ContactToolbar
        setExport={setExportContact}
        contactList={contactList.length}
        selectedContact={selectedContact.length}
        onSelectAll={handleSelectAllContact}
        onOpenSidebar={onOpenSidebar}
        numSelected={numSelected}
        onDeselectAll={handleDeselectAllContact}
        handleParamAssigner={handleParamAssigner}
        paramSearch={paramSearch}
        onToggleDense={handleToggleDense}
        handleAttributeContactSearch={handleAttributeContactSearch}
        rowsPerPageOptions={[5, 10, 25]}
        tableHeadContact={tableHeadContact}
        resetAllSearch={resetAllSearch}
        handleAttributeContact={handleAttributeContact}
        handleParamSearch={handleParamSearch}
        totalContact={totalContact}
        rowsPerPage={rowsPerPage}
        page={page}
        setPage={setPage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />

      <Divider />
      <Box sx={{ width: "100%", display: "flex", p: 1 }}>
        <Box
          sx={{ width: "50%", display: "flex", justifyContent: "flex-start" }}
        >
          <Button
            ref={anchorOptionContactRef}
            onClick={handleOpenOptionContact}
            startIcon={<AddCircleIcon />}
            color="secondary"
            variant="contained"
            sx={{ mr: 1 }}
          >
            {" "}
            Tùy chọn danh bạ{" "}
          </Button>
          <MenuPopover
            sx={{ width: "auto" }}
            open={isOpenOptionContact}
            onClose={() => setIsOpenOptionContact(false)}
            anchorEl={anchorOptionContactRef.current}
          >
            <Stack direction={"column"} justifyContent={"flex-start"}>
              <MenuItem
                onClick={() => setIsOpenDialogChangeAssigner(true)}
                sx={{ display: "block" }}
              >
                <Typography> Chuyển người phụ trách</Typography>
              </MenuItem>
              <MenuItem
                onClick={() => onHandleDeleteChecked(true)}
                sx={{ display: "block" }}
              >
                <Typography> Xóa danh bạ</Typography>
              </MenuItem>
            </Stack>
          </MenuPopover>
        </Box>
        <Box sx={{ width: "50%", display: "flex", justifyContent: "flex-end" }}>
          <Button
            variant="contained"
            sx={{ mr: 1 }}
            color="secondary"
            onClick={() => setExportContact(1)}
            startIcon={<DownloadForOfflineIcon />}
          >
            Tải xuống danh sách
          </Button>
          <Button
            ref={anchorRef}
            onClick={handleOpen}
            startIcon={<AddCircleIcon />}
            color="secondary"
            variant="contained"
            sx={{ mr: 1 }}
          >
            {" "}
            Cấu hình hiển thị{" "}
          </Button>
        </Box>
      </Box>

      <MenuPopover
        sx={{ width: "auto" }}
        open={isOpenConfiguration}
        onClose={handleClose}
        anchorEl={anchorRef.current}
      >
        <Stack
          sx={{ width: "315px", p: 1 }}
          direction={"column"}
          justifyContent={"flex-start"}
        >
          <Typography>Thuộc tính11</Typography>
          {tableHeadContact.map((attr) => {
            if (!attr.is_hidden_table) {
              return (
                <FormControlLabel
                  label={t(attr.field_name)}
                  name={attr.field_variable}
                  onChange={handleAttributeContact}
                  control={<Checkbox defaultChecked={attr.is_show_table} />}
                />
              );
            }
          })}
        </Stack>
      </MenuPopover>
      <TableContainer
        sx={{ minWidth: 800, height: "60vh", mt: 1, width: "100%" }}
      >
        <Table stickyHeader>
          <ContactListHead
            order={order}
            contactList={contactList}
            orderBy={orderBy}
            headLabel={tableHeadContact}
            rowCount={contactList.length}
            numSelected={selected.length}
            selected={selected}
            // onRequestSort={handleRequestSort}
            onSelectAllClick={handleSelectAllClick}
            rowsPerPage={rowsPerPage}
            page={page}
            // onPageChange={handleChangePage}
            // onRowsPerPageChange={handleChangeRowsPerPage}
          />
          <TableBody>
            {contactList.map((row) => {
              const {
                _id,
                full_name,
                name,
                phone,
                assigned_by_name,
                avatarUrl,
                status,
                other,
                tags,
              } = row;
              const infoContactClone = row;
              const isItemSelected = selected.indexOf(objectID(_id)) !== -1;

              return (
                <TableRow
                  hover
                  key={objectID(_id)}
                  tabIndex={-1}
                  role="checkbox"
                  selected={isItemSelected}
                  aria-checked={isItemSelected}
                >
                  <TableCell padding="checkbox">
                    <Stack
                      direction={"row"}
                      justifyContent={"center"}
                      sx={{ mr: "10px" }}
                    >
                      <Checkbox
                        checked={isItemSelected}
                        onChange={(event) => handleClick(event, objectID(_id))}
                      />
                    </Stack>
                  </TableCell>
                  {tableHeadContact.map((headContact) => {
                    if (headContact.is_show_table) {
                      if (headContact.field_variable === "name") {
                        return (
                          <TableCell
                            sx={{ cursor: "pointer" }}
                            component="th"
                            scope="row"
                            padding="none"
                            onClick={() => handleSelectedContact(row, page)}
                          >
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={2}
                            >
                              <Avatar alt={full_name} src={avatarUrl} />
                              <Typography variant="body2">
                                {name?.length <= 30
                                  ? name
                                  : name.substr(0, 30) + "..."}
                              </Typography>
                            </Stack>
                          </TableCell>
                        );
                      } else if (headContact.name === "status") {
                        return (
                          <TableCell align="left" sx={{ maxWidth: 200 }}>
                            <Label
                              variant={
                                theme.palette.mode === "light"
                                  ? "ghost"
                                  : "filled"
                              }
                              color={
                                (status === "disabled" && "error") || "success"
                              }
                            >
                              {sentenceCase(status)}
                            </Label>
                          </TableCell>
                        );
                      } else if (headContact.field_variable === "assigned_by") {
                        return (
                          <TableCell align="left">
                            <Typography variant="body2" sx={{ width: 200 }}>
                              {renderAssignBy(assigned_by_name)}
                            </Typography>
                          </TableCell>
                        );
                      } else if (headContact.field_variable === "tag") {
                        if (tags && tags.length > 0) {
                          return (
                            <RenderTagsCell
                              tags={row.tags}
                              headContact={headContact}
                              row={row}
                              handleDeleteTag={handleDeleteTag}
                              handleOpenDialogTag={handleOpenDialogTag}
                            />
                          );
                        }
                        return (
                          <TableCell align="center">
                            <Chip
                              onClick={() => handleOpenDialogTag(row)}
                              icon={<AddIcon />}
                              label="Thêm mới"
                              variant="outlined"
                              sx={{ border: "1px dashed", cursor: "pointer" }}
                            ></Chip>
                          </TableCell>
                        );
                      } else if (headContact.field_type === "select") {
                        var info_selected = other
                          ? other.filter(
                              (info) => info.k === headContact.field_variable
                            )
                          : [];
                        if (info_selected?.length > 0) {
                          var info_option = headContact.field_options.filter(
                            (option) => option.key === info_selected[0].v
                          );
                          return (
                            <TableCell align="left" sx={{ width: 200 }}>
                              <Typography variant="body2" sx={{ width: 200 }}>
                                {info_option.length > 0
                                  ? info_option[0].label
                                  : ""}
                              </Typography>
                            </TableCell>
                          );
                        } else {
                          return <TableCell align="left"></TableCell>;
                        }
                      } else if (headContact.field_type === "multiselect") {
                        const selectedOption = other?.find(
                          (info) => info.k === headContact.field_variable
                        );

                        // Extract the array of values from the selectedOption
                        const selectedValues = selectedOption?.v || [];

                        // Map the selected values to their corresponding labels
                        const optionLabels = headContact.field_options
                          .filter((option) =>
                            selectedValues.includes(option.key)
                          )
                          .map((option) => option.label);

                        // Return the joined labels or an empty string
                        // return optionLabels.length > 0 ? optionLabels.join(", ") : "";

                        if (optionLabels.length > 0) {
                          return (
                            <TableCell align="left" sx={{ maxWidth: 200 }}>
                              {optionLabels.length > 0
                                ? optionLabels.join(", ")
                                : ""}
                            </TableCell>
                          );
                        } else {
                          return <TableCell align="left"></TableCell>;
                        }
                      } else if (headContact.field_type === "dateTime") {
                        var info_selected =
                          other && headContact.is_default === 0
                            ? other.filter(
                                (info) => info.k === headContact.field_variable
                              )
                            : null;
                        return (
                          <TableCell align="left" sx={{ maxWidth: 300 }}>
                            <Tooltip
                              title={
                                info_selected && info_selected[0]?.v
                                  ? new Date(
                                      info_selected[0].v * 1000
                                    ).toLocaleString()
                                  : row[headContact.field_variable]
                              }
                              placement="top"
                              arrow
                            >
                              <Typography
                                sx={{
                                  fontSize: 14,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  display: "block",
                                  textAlign: "center",
                                  cursor: "pointer",
                                  fontWeight: 500,
                                }}
                              >
                                {info_selected && info_selected[0]?.v
                                  ? new Date(
                                      info_selected[0].v * 1000
                                    ).toLocaleString()
                                  : row[headContact.field_variable]}
                              </Typography>
                            </Tooltip>
                          </TableCell>
                        );
                      } else {
                        //kiểm tra xem nó thuộc biến other hay mặc định
                        var info_selected =
                          other && headContact.is_default === 0
                            ? other.filter(
                                (info) => info.k === headContact.field_variable
                              )
                            : null;
                        return (
                          <TableCell align="left" sx={{ maxWidth: 300 }}>
                            <Tooltip
                              title={
                                info_selected
                                  ? info_selected[0]?.v
                                  : row[headContact.field_variable]
                              }
                              placement="top"
                              arrow
                            >
                              <Typography
                                sx={{
                                  fontSize: 14,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  WebkitLineClamp: 1,
                                  WebkitBoxOrient: "vertical",
                                  display: "block",
                                  textAlign: "center",
                                  whiteSpace: "nowrap",
                                  cursor: "pointer",
                                  fontWeight: 500,
                                }}
                              >
                                {info_selected
                                  ? info_selected[0]?.v
                                  : row[headContact.field_variable]}
                              </Typography>
                            </Tooltip>
                          </TableCell>
                        );
                      }
                    }
                  })}

                  <TableCell align="center" sx={{ width: 200, flex: 1 }}>
                    <ContactItemAction
                      handleOpenModalTicket={() => handleOpenModalTicket(row)}
                      handleOpenModalSend={() => handleOpenModalSend(row)}
                      handleCall={() => handleCall(phone, infoContactClone)}
                      handleChat={() => handleChat(row)}
                      handleDelete={() => handleDelete(objectID(_id))}
                      className="showActions"
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <Divider />
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        count={totalContact}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        sx={{ p: 0, borderTop: "none" }}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <AlertFormListChat
        listChatContact={listChatContact}
        open={openDialog}
        onClose={() => onCloseDialog(false)}
      ></AlertFormListChat>
      {openDialogTag && (
        <AlertFormTag
          loadListContact={loadListContact}
          loadFieldContact={loadFieldContact}
          infoTagSelected={infoTagSelected}
          open={openDialogTag}
          onClose={() => onCloseDialogTag(false)}
        />
      )}
      {isShowActionTiket && (
        <FormActionTicket
          isReadOnly={isReadOnly}
          setRefreshTicket={setRefreshTicket}
          selectedTicket={selectedTicket}
          isOpen={isShowActionTiket}
          onClose={handleCloseActionTicket}
          onDeleteTask={() => {}}
          taskCompleted={taskCompleted}
          setTaskCompleted={setTaskCompleted}
          quickInfoContactAdd={infoAddTicket}
        />
      )}
      {isOpenDialogTransferContact && (
        <DialogTransferContact
          isOpenDialogTransferContact={isOpenDialogTransferContact}
          onClose={() => setIsOpenDialogTransferContact(false)}
        />
      )}
      {isOpenDialogChangeAssigner && (
        <DialogChangeAssigner
          paramSearch={paramSearch}
          setIsRefreshContact={setIsRefreshContact}
          loadListContact={loadListContact}
          contactSelected={selected}
          isOpenDialogChangeAssigner={isOpenDialogChangeAssigner}
          onClose={() => handleCloseAssigner()}
        />
      )}
      <DialogAnimate
        fullWidth
        maxWidth="md"
        open={isOpenModalSend}
        onClose={handleCloseModalSend}
      >
        <DialogSendMessage
          contact={selectContact}
          isOpenModalSend={isOpenModalSend}
          handleCloseModalSend={handleCloseModalSend}
        ></DialogSendMessage>
      </DialogAnimate>
    </RootStyle>
  );
}
